import Player from "../objects/player";
import Gun from "./Gun";
import { powerUpType, bulletType } from "../assets/data/enum";
import InfoBar from "../objects/infobar";

export default class PowerUp {

    private _parent: Player;
    private _gun: Gun
    private _gun1: Gun;
    private _gun2: Gun;
    private _MAX_TIME: number = 0.016 * 60 * 8;
    private _timeElapsed: number = 0;
    private _stopCallback: Function;
    private _type: string;
    private _keys: Array<string>;
    private _startMethods: Array<Function>;
    private _stopMethods: Array<Function>;
    private _banner: Phaser.GameObjects.Image;
    private _bannerTween: Array<Phaser.Tweens.Tween> = [];
    private _scene: Phaser.Scene;

    private _timer: InfoBar;
    private _timerIcon: Phaser.GameObjects.Image;
    private _timerContainer: Phaser.GameObjects.Container;
    private _timerOn: boolean = false;

    private _updateCounter: number;
    private _updateCounterMax: number;

    public active: boolean = false;
    public flags: {
        "shield": boolean,
        "2x": boolean,
        "magnet": boolean,
        "split_shooter": boolean
    }
    public key: string;
    constructor(scene: Phaser.Scene, parent: Player, stopCallback: Function) {
        this._parent = parent;
        this._stopCallback = stopCallback || function () { };
        this._scene = scene;
        this._init();
    }

    private _init() {
        // let container = this._parent.parentContainer;
        // create all the power basic data
        this._keys = Object.keys(powerUpType);

        // must follow the same order as specified in the enum file
        this._startMethods = [
            this._shieldStart.bind(this),
            this._magnetStart.bind(this),
            this._tripleShootStart.bind(this)
        ]

        this._stopMethods = [
            this._shieldStop.bind(this),
            this._magnetStop.bind(this),
            this._tripleShootStop.bind(this)
        ]

        this.flags = {
            "shield": false,
            "2x": false,
            "magnet": false,
            "split_shooter": false
        }
        let scene = this._scene;
        let banner = scene.textures.getFrame("assets", "banner_magnet");
        let x = window.constants.BASE_WIDTH / 2, y = window.constants.BASE_HEIGHT * 0.25;
        let timerBar = scene.textures.getFrame("assets",'timer_bar');
        this._banner = scene.add.image(0, (window.constants.BASE_HEIGHT / 2), null);
        this._banner.setOrigin(0.5, 0.5);
        this._bannerTween[0] = scene.add.tween({
            targets: this._banner,
            x: { from: (-(banner.width)), to: (window.constants.BASE_WIDTH / 2) },
            callbackScope: this,
            onComplete: function () { this._bannerTween[1].restart(); },
            ease: Phaser.Math.Easing.Back.In,
            duration: 500,
            repeat: 0,            // -1: infinity
            yoyo: false
        })

        this._bannerTween[1] = scene.add.tween({
            targets: this._banner,
            delay: 750,
            x: { from: (window.constants.BASE_WIDTH / 2), to: window.constants.BASE_WIDTH + (banner.width) },
            callbackScope: this,
            onComplete: function () { this._timerOn = true },
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            repeat: 0,            // -1: infinity
            yoyo: false
        })

        this._timer = new InfoBar(scene, null, this._MAX_TIME, timerBar.width, timerBar.height, "assets", 'timer_bar', false, x, y);
        this._timerIcon = scene.add.image(x - timerBar.width / 2, y, null);
        this._timerIcon.setScale(0.8);

        // container.add(this._banner);
        // container.add(this._timerIcon);

        this._hideUI();

        this._updateCounter = 3;
        this._updateCounterMax = 3;
    }


    private _tripleShootStart() {
        this._parent.changeGun(bulletType.split_shooter);
    }

    private _tripleShootStop() {
        this._parent.changeGun(bulletType.player);
    }

    private _shieldStart() {
        this.flags.shield = true;
        this._parent.setShieldFxVisibility(true);
    }

    private _shieldStop() {
        this.flags.shield = false;
        this._parent.setShieldFxVisibility(false);
    }

    private _magnetStart() {
        this._parent.setMagnetRadius(window.constants.BASE_HEIGHT);
        this._parent.setMagnetFxVisibility(true);
    }

    private _magnetStop() {
        this._parent.setMagnetRadius(0);
        this._parent.setMagnetFxVisibility(false);
    }

    private _showUI(key) {
        this._setVisibility(this._banner, true);
        this._setVisibility(this._timerIcon, true);

        this._banner.setTexture("assets", 'banner_' + key);
        this._timerIcon.setTexture("assets", key);

        this._bannerTween[0].restart();
        this._timer.start();

    }

    private _hideUI() {
        this._setVisibility(this._banner, false);
        this._setVisibility(this._timerIcon, false);
        this._timer.stop();
    }

    private _setVisibility(image: Phaser.GameObjects.Image, show: boolean) {

        image.setActive(show);
        image.setVisible(show);
    }

    public start(key) {
        if (this.active) {
            this.stop();
        }
        this._timeElapsed = this._scene.time.now;
        this._timerOn = true;
        this.flags[key] = true;
        this.active = true;
        this.key = key;
        if (this._startMethods[powerUpType[key]]) {
            this._startMethods[powerUpType[key]]();
        }
        this._showUI(key);
    }

    public stop() {
        this._timerOn = false;
        this.active = false;
        this._timeElapsed = 0;
        if(this.key) {
            this.flags[this.key] = false;
            if (this._stopMethods[powerUpType[this.key]]) {
                this._stopMethods[powerUpType[this.key]]();
            }
        }
        this._hideUI();
        this._stopCallback();
        this.key = null;
    }

    public setDepth(z) {
        this._timer.setDepth(z);
        this._timerIcon.setDepth(z);
        this._banner.setDepth(z);
    }

    update(time, dt) {
        if(!this._updateCounter--) {
            this._updateCounter = this._updateCounterMax;
            if (this._timerOn) {
                let elapsed = ((time - this._timeElapsed) * 0.001);
                if (elapsed < this._MAX_TIME) {
                    // shoot code
                    // this._timeElapsed += dt;
                    this._timer.setValue(this._MAX_TIME - elapsed);
                }
                else {
                    this.stop();
                    // this._stopCallback();
                }
            }
        }
    }
}